import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface BannerContentProps {
  description?: string;
  hasMedia?: boolean;
  title: string;
}

export const BannerContent = ({
  description,
  hasMedia = false,
  title,
}: BannerContentProps) => (
  <div
    className={classNames(
      "welcome-banner__content-wrapper !bg-primary !border-primary rounded-none !p-5 md:rounded-b-2xl md:!px-6",
      {
        "has-title": title.length > 0,
        "md:rounded-2xl": !hasMedia,
      },
    )}
  >
    {title && (
      <Typography.TitleLg data-testid="welcome-banner-title">
        {title}
      </Typography.TitleLg>
    )}
    {description && (
      <div
        className="welcome-banner__content"
        data-testid="welcome-banner-content"
      >
        <div
          className="text-dark"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    )}
  </div>
);
